import {useTranslation} from 'react-i18next';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {Box, Typography} from '@mui/material';

import {scorePill} from '../../../../../layouts/theme/designSystem';

export interface Props {
  message: string;
}

export const WorkforceProfileProcessingErrorBanner = ({message}: Props) => {
  const {t} = useTranslation('translation', {
    keyPrefix: 'workforceProfilesPage.detail.processingError',
  });

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        alignItems: 'flex-start',
        py: 1.5,
        px: 2,
        borderRadius: '10px',
        bgcolor: scorePill.medium.bgcolor,
        color: scorePill.medium.color,
        border: `1px solid ${scorePill.medium.strokeColor}`,
        mb: 2,
      }}
    >
      <WarningAmberIcon sx={{fontSize: 20, flexShrink: 0, mt: 0.125}} />
      <Box>
        <Typography sx={{fontSize: 13, fontWeight: 600, mb: 0.25, color: 'inherit'}}>{t('bannerTitle')}</Typography>
        <Typography sx={{fontSize: 12.5, lineHeight: 1.5, color: 'inherit'}}>{message}</Typography>
        <Typography sx={{fontSize: 12, lineHeight: 1.45, color: 'inherit', mt: 0.5, opacity: 0.9}}>
          {t('bannerHint')}
        </Typography>
      </Box>
    </Box>
  );
};
